exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pagination-item{background-image:none;display:inline;list-style-type:none;padding:2px;background-color:#efebe7!important;border:1px solid #266996;margin:0 2px!important}.pagination-item.active{background-color:#d9dbcd!important;margin:0 4px!important;padding:4px!important}.pagination-item.active div{color:#333}.pagination-item:hover{cursor:pointer}.pagination-item div{color:#27638c;font-size:1em;font-weight:700;padding:4px;text-decoration:none;display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/search/FormElements/paginatorItem/pagination.less
// module id = 1634
// module chunks = 0